import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStore } from '../../store';
import SucursalList from './list/SucursalList';
import SucursalesLoadFile from './files/SucursalesLoadFile';

class Sucursal extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Sucursal');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowEdit = (data) => {
    this.props.history.replace({
      pathname: `/cuenta/sucursal/${data.id}/editar`,
      state: {
        data: { ...data },
      },
    });
  };

  handleOnShowLoadFile = () => {
    this.setState({
      isLoadFile: true,
    });
  };

  handleOnCloseLoadFile = () => {
    this.setState({
      isLoadFile: false,
    });
  };

  handleOnDataFile = (values) => {
    const { data } = this.props;

    const body = {
      sucursales: values,
    };

    this.props.upsert(body, data.id);
  };

  render() {
    const { data = {}, isLoadFile } = this.state;

    return (
      <div>
        {isLoadFile && (
          <SucursalesLoadFile
            data={data}
            show={isLoadFile}
            onAdd={this.handleOnDataFile}
            onClose={this.handleOnCloseLoadFile}
          />
        )}
        <Row className="mb-3">
          <Col>
            {Guardian.allows('sucursal.crear') && (
              <Link
                to="/cuenta/sucursal/registrar"
                className="mr-3"
              >
                <Button>Nueva Sucursal</Button>
              </Link>
            )}

            {Guardian.allows('sucursal.load.excel') && (
              <Button
                variant="secondary"
                onClick={this.handleOnShowLoadFile}
              >
                <FontAwesomeIcon icon={['fas', 'upload']} /> Usar excel
              </Button>
            )}
          </Col>
        </Row>

        {Guardian.allows('sucursal.listar') && (
          <SucursalList
            onEdit={this.handleOnRowEdit}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => {
  return {
    ...state.cuenta.sucursal.upsert,
  };
};

const mapActions = (actions) => {
  return {
    ...actions.cuenta.sucursal.upsert,
  };
};

export default connect(useStore, mapState, mapActions)(Sucursal);
